var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 60C47.0167 60 60 47.0167 60 31C60 14.9833 47.0167 2 31 2C14.9833 2 2 14.9833 2 31C2 47.0167 14.9833 60 31 60Z",
    stroke: "#018C0D",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 48.5C41.5 48.5 38.5 42.5 31 42.5C23.5 42.5 20.5 48.5 20.5 48.5M47.5 23L37 21.5M44.5 23V36.5M25 21.5L14.5 23M17.5 23V36.5",
    stroke: "#018C0D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCry);
export default __webpack_public_path__ + "static/media/cry.d830761e265108fa2d14c09d381c6bb8.svg";
export { ForwardRef as ReactComponent };